import { render, staticRenderFns } from "./vehicle-chart.vue?vue&type=template&id=81107066&scoped=true"
import script from "./vehicle-chart.vue?vue&type=script&lang=js"
export * from "./vehicle-chart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81107066",
  null
  
)

export default component.exports